import { Box, useTheme } from "@mui/material";
import { useMediaQuery } from "../utilities/index.js";
import React from "react";
export const HeroHeaderContainer = ({ backgroundColor, children, id, sticky = true, sx = {}, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    return (React.createElement(Box, { id: id, sx: {
            backgroundColor: backgroundColor,
            boxShadow: {
                xs: sticky ? "none" : "sectionBottom",
                md: "sectionBottom",
            },
            height: "100%",
            left: 0,
            position: { xs: sticky ? "sticky" : "relative", md: "relative" },
            top: 0,
            width: "100%",
            zIndex: { xs: sticky ? 0 : 11, md: 11 },
            "&::after": isMobile && sticky
                ? {
                    background: backgroundColor,
                    bottom: "-2rem",
                    content: "''",
                    height: "2rem",
                    left: 0,
                    position: "absolute",
                    width: "100%",
                }
                : {},
            ...sx,
        } }, children));
};
export const HeroHeaderBelowContainer = ({ children, id = "below-hero-header-content", sx = {}, }) => (React.createElement(Box, { id: id, sx: {
        background: "white",
        borderTopLeftRadius: { xs: "16px", md: 0 },
        borderTopRightRadius: { xs: "16px", md: 0 },
        position: "relative",
        zIndex: 10,
        overflowX: "hidden",
        ...sx,
    } }, children));
//# sourceMappingURL=hero-header.js.map